import { Instagram, Heart, MessageCircle, Send, Bookmark } from "lucide-react";
import type { PreviewProps } from "../types";
import { PreviewShell, MediaSlot } from "./PreviewShell";

export function InstagramPreview(props: PreviewProps) {
  return (
    <PreviewShell device={props.device} mobileFrame={false}>
      <div className="flex items-center gap-2.5 p-3">
        {props.pageAvatarUrl ? (
          <img
            src={props.pageAvatarUrl}
            alt={props.pageName}
            className="w-8 h-8 rounded-full object-cover bg-gray-100"
          />
        ) : (
          <div className="w-8 h-8 rounded-full flex items-center justify-center bg-gradient-to-br from-pink-500 via-red-500 to-yellow-500">
            <Instagram size={14} className="text-white" />
          </div>
        )}
        <p className="text-[12px] font-semibold text-gray-900 truncate flex-1">{props.pageName}</p>
        <span className="text-gray-400">···</span>
      </div>
      <MediaSlot mediaUrl={props.mediaUrl} mediaType={props.mediaType} aspect="aspect-square" />
      <div className="flex items-center gap-3 px-3 py-2 text-gray-700">
        <Heart size={20} />
        <MessageCircle size={20} />
        <Send size={20} />
        <Bookmark size={20} className="ml-auto" />
      </div>
      {props.caption && (
        <div className="px-3 pb-3">
          <p className="text-[12px] text-gray-800">
            <span className="font-semibold mr-1.5">{props.pageName}</span>
            <span className="whitespace-pre-wrap">{props.caption}</span>
          </p>
        </div>
      )}
    </PreviewShell>
  );
}
